var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonCarryBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 0.5C3.78906 0.5 4.375 0.890625 4.72656 1.4375C5.07812 2.02344 5.07812 2.76562 4.72656 3.3125C4.375 3.89844 3.78906 4.25 3.125 4.25C2.42188 4.25 1.83594 3.89844 1.48438 3.3125C1.13281 2.76562 1.13281 2.02344 1.48438 1.4375C1.83594 0.890625 2.42188 0.5 3.125 0.5ZM0 19.5625V13.8203L0.0390625 13.8594L1.875 15.3047V19.5625C1.875 20.1094 1.44531 20.5 0.9375 20.5C0.390625 20.5 0 20.1094 0 19.5625ZM2.30469 7.375C2.07031 7.375 1.875 7.57031 1.875 7.84375V11.1641C1.875 11.2422 1.91406 11.3594 1.99219 11.3984L2.8125 12.0625V7.49219C2.65625 7.45312 2.46094 7.375 2.30469 7.375ZM4.6875 10.1484V13.5078L5.66406 14.3281C5.97656 14.5625 6.21094 14.9141 6.25 15.3047L6.83594 19.4453C6.91406 19.9531 6.5625 20.4219 6.05469 20.5C5.54688 20.5781 5.07812 20.2266 5 19.7188L4.41406 15.6953L0.820312 12.8828C0.273438 12.4531 0 11.8281 0 11.1641V7.84375C0 6.55469 1.01562 5.5 2.30469 5.5C3.32031 5.5 4.25781 6.04688 4.80469 6.90625L6.75781 9.875H7.5V5.5C7.5 4.83594 8.04688 4.25 8.75 4.25H13.75C14.4141 4.25 15 4.83594 15 5.5V10.5C15 11.2031 14.4141 11.75 13.75 11.75H9.0625H8.75H6.5625C6.05469 11.75 5.54688 11.5156 5.27344 11.0469L4.6875 10.1484ZM9.375 9.875H13.125V6.125H9.375V9.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCarryBox);
export default __webpack_public_path__ + "static/media/person-carry-box.0b1918a0d37f8a206492762cdfb10b4c.svg";
export { ForwardRef as ReactComponent };